var _path, _path2, _g, _circle, _path3, _path4, _path5, _path6, _path7, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertStep3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 272,
    height: 220,
    viewBox: "0 0 272 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3245 66.1925C15.4065 55.3146 22.6698 44.9414 33.5477 43.0234L189.794 15.4729C200.672 13.5549 211.045 20.8183 212.963 31.6961L213.313 33.6833L215.225 44.5249L217.137 55.3665L224.783 98.7331L236.604 165.77C238.522 176.648 231.259 187.021 220.381 188.939L64.1345 216.49C53.2566 218.408 42.8834 211.144 40.9654 200.266L29.1449 133.229L21.4983 89.8629L19.5866 79.0212L17.6749 68.1796L17.3245 66.1925Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9336 78.0222L213.618 44.0468L211.486 31.9566C209.712 21.8946 200.116 15.1759 190.054 16.9502L33.8082 44.5006C23.7461 46.2748 17.0275 55.87 18.8017 65.932L20.9336 78.0222ZM17.3245 66.1925C15.4065 55.3146 22.6698 44.9414 33.5477 43.0234L189.794 15.4729C200.672 13.5549 211.045 20.8183 212.963 31.6961L236.604 165.77C238.522 176.648 231.259 187.021 220.381 188.939L64.1345 216.49C53.2566 218.408 42.8834 211.144 40.9654 200.266L17.3245 66.1925ZM213.878 45.524L235.127 166.03C236.901 176.092 230.182 185.688 220.12 187.462L63.874 215.012C53.812 216.787 44.2168 210.068 42.4426 200.006L21.194 79.4994L213.878 45.524Z",
    fill: "#F7BA97"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_7087_117079)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 12,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.807 34.7151H125.057C125.057 36.5207 123.594 37.9845 121.788 37.9845H120.807V34.7151Z",
    fill: "#F7BA97"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.192 24.907C135.192 28.8793 131.972 32.0996 128 32.0996C126.951 32.0996 125.955 31.8753 125.057 31.4721V34.0612H120.807V24.907C120.807 20.9346 124.027 17.7144 128 17.7144C131.972 17.7144 135.192 20.9346 135.192 24.907ZM124.076 24.907C124.076 22.9241 125.83 21.3107 127.993 21.3107C130.156 21.3107 131.923 22.9241 131.923 24.907C131.923 26.8898 130.156 28.5033 127.993 28.5033C125.83 28.5033 124.076 26.8882 124.076 24.907Z",
    fill: "#F7BA97"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 193.75,
    cy: 32.0696,
    r: 5.29751,
    transform: "rotate(-10 193.75 32.0696)",
    fill: "#F7BA97"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.062 38.3392C182.127 37.975 183.507 36.0054 183.142 33.9399C182.778 31.8745 180.809 30.4954 178.743 30.8596C176.678 31.2237 175.299 33.1934 175.663 35.2588C176.027 37.3242 177.997 38.7034 180.062 38.3392ZM180.322 39.8164C183.204 39.3083 185.128 36.5608 184.62 33.6795C184.112 30.7982 181.364 28.8743 178.483 29.3823C175.601 29.8904 173.677 32.638 174.186 35.5193C174.694 38.4006 177.441 40.3244 180.322 39.8164Z",
    fill: "#F7BA97"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.714 40.869C167.78 40.5048 169.159 38.5352 168.795 36.4697C168.431 34.4043 166.461 33.0251 164.395 33.3893C162.33 33.7535 160.951 35.7231 161.315 37.7886C161.679 39.854 163.649 41.2332 165.714 40.869ZM165.975 42.3462C168.856 41.8381 170.78 39.0905 170.272 36.2093C169.764 33.328 167.016 31.4041 164.135 31.9121C161.254 32.4202 159.33 35.1678 159.838 38.0491C160.346 40.9303 163.094 42.8542 165.975 42.3462Z",
    fill: "#F7BA97"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.794 196.191C77.114 196.191 74.6469 195.715 72.3926 194.763C70.1384 193.812 68.1973 192.459 66.5692 190.706C64.9411 188.928 63.7514 186.811 63 184.356L68.2599 182.778C69.1616 185.458 70.6393 187.487 72.6932 188.865C74.7721 190.242 77.114 190.906 79.7189 190.856C82.1234 190.806 84.1898 190.268 85.918 189.241C87.6713 188.214 89.0114 186.786 89.9381 184.958C90.8648 183.129 91.3282 181.013 91.3282 178.608C91.3282 174.926 90.2512 171.971 88.0971 169.741C85.9681 167.487 83.1503 166.36 79.6438 166.36C78.6669 166.36 77.64 166.498 76.563 166.773C75.486 167.024 74.4841 167.387 73.5573 167.863L70.7771 163.467L91.8166 144.043L92.7183 146.297H65.1415V141H96.4002V146.373L78.0658 163.88L77.9907 161.701C81.7477 161.225 85.0539 161.651 87.9093 162.979C90.7646 164.306 92.9938 166.335 94.5968 169.065C96.2249 171.77 97.0389 174.951 97.0389 178.608C97.0389 182.065 96.2875 185.12 94.7847 187.775C93.3069 190.405 91.2656 192.472 88.6607 193.974C86.0558 195.452 83.1003 196.191 79.794 196.191Z",
    fill: "#FCE5D8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5824 153.06L8.01105 140.18L2.0748 146.116L21.1195 165.188L53.1843 133.119L46.8326 126.82L21.6603 153.055L21.1237 153.615L20.5824 153.06Z",
    stroke: "#F7BA97",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2971 141.97L33.8855 152.421L53.1844 133.119L46.8327 126.821L32.2971 141.97Z",
    fill: "#F7BA97",
    stroke: "#F7BA97",
    strokeWidth: 1.5
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_7087_117079)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 123,
    y: 87,
    width: 56,
    height: 56,
    rx: 6,
    transform: "rotate(-10 123 87)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.013 98.9026L168.252 119.169L168.18 122.351C168.163 123.124 167.555 123.754 166.783 123.8L165.106 123.9L165.271 126.603C165.321 127.422 164.697 128.126 163.878 128.176L160.757 128.367C159.938 128.417 159.234 127.794 159.184 126.975L159.018 124.263L155.974 124.445L152.931 124.627L153.096 127.347C153.146 128.166 152.522 128.87 151.704 128.92L148.583 129.11C147.764 129.16 147.06 128.537 147.01 127.718L146.843 124.99L145.036 125.098C144.32 125.14 143.675 124.665 143.505 123.969L142.737 120.841L140.264 112.712L139.027 108.648L138.279 106.189C138.019 105.336 138.564 104.448 139.442 104.293L144.646 103.375L150.988 102.257L157.33 101.139L163.671 100.021L170.013 98.9026Z",
    fill: "#F7BA97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.221 99.6022L169.383 96.0033L169.494 93.548C169.524 92.8741 170.005 92.3052 170.664 92.1627L173.774 91.491L175.888 91.0343",
    stroke: "#F7BA97",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.15 123.718L165.106 123.9M143.8 125.171L146.844 124.99M168.252 119.169L163.043 119.51L157.835 119.852L152.626 120.193L147.417 120.534L142.737 120.841M152.931 124.627L155.975 124.445L159.019 124.263M152.931 124.627L149.887 124.808L148.366 124.899L146.844 124.99M152.931 124.627L153.096 127.347C153.146 128.166 152.523 128.87 151.704 128.92L148.584 129.11C147.765 129.16 147.06 128.537 147.01 127.718L146.844 124.99M165.106 123.9L163.584 123.991L162.062 124.082L159.019 124.263M165.106 123.9L165.271 126.603C165.321 127.422 164.698 128.126 163.879 128.176L160.757 128.367C159.939 128.417 159.234 127.794 159.184 126.975L159.019 124.263",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_7087_117079",
    x: 87,
    y: -1,
    width: 82,
    height: 82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7087_117079"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_7087_117079",
    result: "effect2_dropShadow_7087_117079"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_7087_117079",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_7087_117079",
    x: 101.81,
    y: 66.6807,
    width: 107.254,
    height: 107.254,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.595
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.595
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7087_117079"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7087_117079",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertStep3);
export default __webpack_public_path__ + "static/media/alert-step3.06c2ee2494977cb4bbf6d1f0226f3a80.svg";
export { ForwardRef as ReactComponent };